export default {
  shipping: 'fracht',
  useMoreAddress: 'Użyj innego adresu',
  hideAddress: 'Zwiń adres',
  productInventory: 'Lista towarów',
  tag: 'Etykieta',
  retainTag: 'Zarezerwowana etykieta',
  delTag: 'Usuń etykietę',
  externalPack: 'Opakowanie zewnętrzne',
  packDetail: 'Szczegóły pakowania',
  postLine: 'Trasa dostawy',
  selectLine: 'Wybierz trasę',
  editLine: 'Modyfikuj trasę',
  service: 'Usługa',
  cancelServe: 'Anuluj usługę',
  previewPackage: 'Podgląd paczki',
  postCountry: 'Kraj wysyłki',
  packageNo: 'Nr paczki',
  deliver: 'Dostawa do',
  packageDetail: 'Szczegóły paczki',
  addressInfo: 'Informacje o adresie',
  voWeight: 'Waga objętościowa',
  firstWeight: 'Pierwsza waga',
  continueWeight: 'Waga dodatkowa',
  actWeight: 'Waga rzeczywista',
  packageStatus: 'Status paczki',
  freightDetail: 'Informacje o kosztach',
  declareCurrency: 'Waluta deklaracji',
  selfDeclare: 'Deklaracja własna',
  packageDeclarePrice: 'Całkowita kwota deklaracji paczki',
  youPackageProduct: 'Towary w Twojej paczce',
  editYourDeclare: 'Edytuj swoje informacje deklaracji',
  startDeclare: 'Rozpocznij deklarację',
  declareType: 'Typ deklaracji',
  productNo: 'ID produktu',
  declareProductPrice: 'Deklarowana cena jednostkowa',
  declareTotalPrice: 'Całkowita kwota deklaracji towarów',
  editDeclare: 'Modyfikuj deklarację',
  declareLinePriceHint:
    'Najniższa całkowita kwota deklaracji dla obecnej linii: {min}, najwyższa: {max}',
  classMaxNumHint: 'Liczba pojedynczych kategorii osiągnęła limit górny {max}',
  addDeclareProduct: 'Dodaj deklarowane towary',
  plsConfirmInfo: 'Potwierdź informacje',
  wipePackProduct: 'Towary niezapakowane',
  foldPackProduct: 'Towary składane',
  wipeTagProduct: 'Towary bez etykiety',
  aboutCalcWeightExplain:
    'Ponieważ paczka nie jest obecnie zapakowana, nie znamy jej prawdziwej wagi na tym etapie, więc możemy polegać tylko na kilku istniejących parametrach, aby oszacować wagę paczki i pobrać zaliczkę. Po zapakowaniu paczki i uzyskaniu prawdziwej wagi, nadwyżka zostanie zwrócona.',
  expressInfo: 'Informacje logistyczne',
  deliveryMode: 'Tryb dostawy',
  targetCountry: 'Kraj docelowy',
  cancelPackage: 'Anuluj paczkę',
  cancelPackageHint:
    'Potwierdzasz anulowanie tej paczki? Po anulowaniu nie będziesz mógł jej odzyskać.',
  isDelPackage: 'Potwierdzasz trwałe usunięcie paczki?',
  delPackageHint:
    'Po trwałym usunięciu nie będziesz już mógł przeglądać paczki, zachowaj ostrożność!',
  receivedTips: 'Twoja paczka została odebrana, zapraszamy ponownie',
  packageQuestion: 'Wystąpił problem z dostawą paczki, możesz',
  afterSale: 'Złożyć wniosek o obsługę posprzedażową',
  repair: 'Dokonać ponownej płatności',
  ucan: 'Możesz',
  clickAdd: 'Kliknąć Dodaj',
  addCategoryTips: 'Nie ma nazwy produktu, który chcesz zadeklarować',
  noCarrierLines: 'Brak dostępnych tras wysyłkowych',
  confirmPackageTitle: 'Czy potwierdzasz odbiór towarów?',
  confirmPackageTips:
    'Aby chronić Twoje prawa do obsługi posprzedażowej, potwierdź odbiór po sprawdzeniu, czy paczka jest prawidłowa',
  receiptSuccess: 'Odbiór udany',
  position: 'Pozycja',
  time: 'Czas',
  duty: 'NIP',
  discountCode: 'Kod rabatowy',
  inputTrueDuty: 'Wprowadź prawidłowy NIP',
  serveStatusEnum: {
    1: 'Zdjęcia na zamówienie',
    2: 'Wydłużony okres przechowywania',
    5: 'spersonalizowane wideo',
  },
  inputCareTime: 'Wybierz czas przechowywania',
  holder: {
    noInputSearch: 'Nr paczki/ID produktu',
    inputEditDeclareInfo: 'Edytuj swoje informacje deklaracji',
    packageRemark: 'Jeśli masz jakieś specjalne wymagania dotyczące paczki, zanotuj je tutaj',
    yourPriceSummary: 'Sumowanie cen',
  },
  calcFee: 'Szacowana opłata',
  realFee: 'Rzeczywista opłata',
  declare: {
    repeatDeclare: 'Typ duplikatu deklaracji',
    addDeclareType: 'Dodaj typ deklaracji',
  },
  feeEnum: {
    totalAmount: 'Szacowana zaliczka',
    deposit: 'Szacowany koszt',
    overLongFee: 'Opłata za przekroczenie długości',
    overWeightFee: 'Opłata za nadwagę',
    remoteFee: 'Opłaty za obszary odległe',
    feeCustoms: 'Opłata manipulacyjna logistyki',
    feeFuel: 'Dopłata paliwowa',
    feeOperation: 'Opłata manipulacyjna',
    feeService: 'Opłata serwisowa',
    valueAddedTax: 'Podatek VAT',
    insuranceService: 'Składka ubezpieczeniowa',
    incrementAmount: 'Opłata za usługi dodatkowe',
    lineDiscount: 'Zniżka na trasę',
    discount: 'Zniżki VIP',
    coupon: 'Wybierz kupon',
    passwordDiscount: 'Hasło promocyjne',
    orderPreDiscount: 'Zniżka na towar',
    insuranceDiscount: 'Zniżka ubezpieczeniowa',
    incrementDiscount: 'Oferta usług dodatkowych',
    preVolumeCal: 'Szacunkowe ważenie',
    actDeposit: 'Fracht po ważeniu',
    actDepositAmount: 'Płatność końcowa',
  },
  ratePaymentEnum: {
    name: 'Metoda płatności podatku',
    0: 'Płatne przez odbiorcę',
    1: 'Platforma GST/VAT',
    2: 'Osobisty GST/VAT',
    3: 'Platforma IOSS',
    4: 'Osobisty IOSS',
    5: 'Firmowy GST/VAT',
    6: 'GST/VAT dostawcy logistycznego',
    7: 'IOSS dostawcy logistycznego',
    8: 'Zwolnione z podatku',
  },
  bagStatusEnum: {
    0: 'Normalna paczka',
    1: 'Zwrot krajowy',
    2: 'Zwrot zagraniczny',
    3: 'Anuluj paczkę',
    4: 'Paczka do ponownej płatności',
  },
  packageStatusEnum: {
    0: 'Oczekuje na przetworzenie',
    1: 'W trakcie przetwarzania',
    2: 'Wysyłka',
    3: 'Wydanie z magazynu',
    4: 'Zapakowane',
    5: 'Zważone',
    6: 'Etykieta została wydrukowana',
    7: 'Akredytowane',
    8: 'Przekazanie',
    9: 'Przesyłka została wysłana',
    20: 'Paczka odebrana',
  },
  declareEnum: {
    name: 'Metoda deklaracji',
    0: 'Deklaracja systemowa',
    1: 'Deklaracja osobista',
  },
  backText: 'Powrót',
  packageInformation: 'Informacje o paczce',
  parcelNumber: 'Nr paczki',
  noValidRule: 'Zadeklarowana kwota nie spełnia reguł: {rule}',
  shippingAgree: 'Umowa wysyłki acbuy',
  haveDiscountCode: 'Mam kod rabatowy',
  inputDiscountCode: 'Wprowadź swój kod rabatowy tutaj',
  expressNo: 'Numer śledzenia',
  coupon: 'Kupon',
  acCare: 'ubezpieczenie',
  noCouponData: 'Żadne kupony nie spełniają warunków rabatu wysyłki.',
  exchange: 'Wymieniać',
  rangeDeclare: 'Całkowita zadeklarowana kwota przekracza przedział',
  'i18n-000001': 'Materiał',
  'i18n-000002': 'Kolor',
  'i18n-000003': 'Model/Rozmiar',
  'i18n-000004': 'Materiał',
  'i18n-000005': 'Deklarować czy nie',
  'i18n-000006': 'Przypomnienie',
  'i18n-000007':
    'Po przesłaniu Acbuy nie zmodyfikuje informacji o deklaracji.Jeśli wstępna odprawa się nie powiedzie, nadal będziemy kontynuować wysyłkę.',
  'i18n-000008':
    '1. Na żądanie brazylijskiego urzędu celnego prosimy o szczegółowe podanie nazwy, materiału, koloru, modelu / rozmiaru, a całkowita deklarowana nazwa produktu nie może przekraczać 5;',
  'i18n-000009':
    '2.Ponieważ małe przesyłki z Brazylii są do użytku osobistego, wiele przesyłek przybywających jednocześnie do celnych zostanie zatrzymanych. Proszę odbierać wiele produktów osobno；',
  'i18n-000010':
    '3. Zaleca się, aby pojedyncza paczka nie przekraczała 4 kg, a każdy towar powinien być zadeklarowany nie mniej niż 3 USD, a produkty o wysokiej wartości(konsole do gier, telefony komórkowe, tablety, komputery itp.) powinny być deklarowane zgodnie z prawdą w jak największym stopniu, aby uniknąć zajęcia celnego;',
  'i18n-000011':
    '4. Lokalne standardy podatkowe w Brazylii: Jeśli deklaracja jest mniejsza niż 50 dolarów amerykańskich, zostanie opodatkowana zgodnie z 17 % ICMS + 20 % cła, a jeśli jest wyższa niż 50 dolarów amerykańskich, zostanie opodatkowana zgodnie z 17 % ICMS + 60 % cła, wyłącznie w celach informacyjnych;',
  'i18n-000012':
    '5. Po przybyciu paczki do Brazylii zwróć uwagę na wiadomość tekstową i e - mail oraz zapłać podatek na czas',
  'i18n-000013': '{ num } szt.',
  'i18n-000014': 'Nazwa produktu',
  cartonWarning:
    'Wymiary i waga Twojej przesyłki przekraczają zalecane limity. Zalecamy wybór opakowania kartonowego, aby zmniejszyć ryzyko uszkodzenia oraz uzyskać lepszy efekt kompresji',
  'i18n-0000003': 'Numer paczki',
  'i18n-0000004': 'Czas złożenia',
  'i18n-0000005': 'Szacowana objętość',
  'i18n-0000006': 'Szacowana waga',
  'i18n-0000007': 'Szacowany koszt',
  'i18n-0000009': 'Metoda wysyłki	',
  'i18n-0000010': 'Numer śledzenia',
  'i18n-0000011': 'Oczekuje na płatność',
  'i18n-0000017': 'Zniżka z użyciem kuponu	',
  'i18n-0000018': 'Adres wysyłki',
  'i18n-0000019': 'Informacje o deklaracji',
  'i18n-0000020': 'Nazwa deklarowanego produktu',
  'i18n-0000021': 'Zadeklarowana wartość	($)',
  'i18n-0000022': 'Ilość',
  'i18n-0000023': 'Suma częściowa	($)',
  'i18n-0000024': 'Zadeklarowana całość',
  'i18n-0000025': 'Informacje o produkcie',
  'i18n-0000026': 'Produkt',
  'i18n-0000027': 'Waga(g)',
  'i18n-0000028': 'Objętość(cm³)',
  'i18n-0000029': 'Szczegóły pakowania	',
  'i18n-0000033': 'Oczekujący zwrot',
  'i18n-0000034': 'Czekanie na dopłate	',
  'i18n-0000035': 'Aktualna objętość',
  'i18n-0000036': 'Naliczana waga',
  'i18n-0000037': 'Aktualny koszt',
  'i18n-0000038': 'Aktualna platność',
  'i18n-0000039': 'Zdjęcia paczki',
  'i18n-0000040': 'Pobierz fakturę za paczkę',
  'i18n-0000041': 'Zwrócone do portfela',
  'i18n-0000042': 'Zwrot',
  'i18n-0000043': 'Dokonana dodatkowa płatność',
  'i18n-0000046': 'Zwiększać',
  'i18n-0000047': 'Zamknąć',
  'i18n-0000048': 'Tor logistyczny',
  'i18n-0000049': 'Informacje o ważeniu',
  'i18n-0000050': 'Zwrócone',
  'i18n-0000051': 'Oczekiwane w Portfelu w ciągu 72h',
  samePreviewTips: 'Ta paczka próbna została już zgłoszona. Czy chcesz ją zgłosić ponownie?',
  confirmSubmitTitle: 'Potwierdź i kontynuuj',
  confirmSubmitContent: `Proszę potwierdzić swój adres dostawy:
Adres dostawy: {address}

Ważna informacja: Wyświetlana waga rozliczeniowa jest wartością szacunkową. Ostateczna waga do rozliczenia zostanie określona na podstawie rzeczywistej wagi po zapakowaniu, zazwyczaj według większej z wag: objętościowej lub rzeczywistej. W przypadku różnicy między szacowaną a ostateczną opłatą, kwota zostanie skorygowana zgodnie z zasadą „zwrot lub dopłata”.`,
}
